import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Firebase from '../Firebase/firebase';
import './FeatureCompletionDashboard.css';

const FeatureCompletionDashboard = () => {
  const { t } = useTranslation();
  const firebase = new Firebase();

  const initialFeatures = [
    { id: 'document_control', domain: 'Documents', percent: 0 },
    { id: 'folder_organization', domain: 'Documents', percent: 0 },
    {
      id: 'manual_automatic_hyperlinking',
      domain: 'Documents',
      percent: 0,
    },
    { id: 'thumbnail_list_preview', domain: 'Documents', percent: 0 },
    {
      id: 'visual_document_comparison',
      domain: 'Documents',
      percent: 0,
    },
    { id: 'favorites', domain: 'Documents', percent: 0 },
    {
      id: 'metadata_document_classification',
      domain: 'Documents',
      percent: 0,
    },
    { id: 'simultaneous_plan_viewing', domain: 'Plans', percent: 0 },
    {
      id: 'document_management_sheet_versioning',
      domain: 'Documents',
      percent: 0,
    },
    { id: 'full_text_search', domain: 'Plans', percent: 0 },
    { id: 'layers', domain: 'Plans', percent: 0 },
    {
      id: 'overlay_side_by_side_comparison',
      domain: 'Plans',
      percent: 0,
    },
    { id: 'as_built_drawings', domain: 'Plans', percent: 0 },
    { id: 'sheet_export_sharing', domain: 'Plans', percent: 0 },
    {
      id: 'unlimited_active_projects',
      domain: 'Projects',
      percent: 0,
    },
    { id: 'unlimited_documents', domain: 'Projects', percent: 0 },
    { id: 'unlimited_photos_360', domain: 'Projects', percent: 0 },
    { id: 'unlimited_sheets', domain: 'Plans', percent: 0 },
    { id: 'document_review_markup', domain: 'Documents', percent: 0 },
    { id: 'advanced_plan_viewing', domain: 'Plans', percent: 0 },
    { id: 'document_layers', domain: 'Plans', percent: 0 },
    { id: 'offline_document_access', domain: 'Mobile', percent: 0 },
    { id: 'measurements_counts', domain: 'Plans', percent: 0 },
    { id: 'share_invite', domain: 'Collaboration', percent: 0 },
    { id: 'photo_storage_sharing', domain: 'Projects', percent: 0 },
    { id: 'marks_stamps', domain: 'Plans', percent: 0 },
    { id: 'notifications', domain: 'Collaboration', percent: 0 },
    { id: 'mobile_access', domain: 'Mobile', percent: 0 },
    { id: 'web_office_access', domain: 'Collaboration', percent: 0 },
    {
      id: 'optimized_large_touchscreens',
      domain: 'Mobile',
      percent: 0,
    },
    {
      id: 'project_management_workflows',
      domain: 'Projects',
      percent: 0,
    },
    { id: 'rfi_pco_change_orders', domain: 'Projects', percent: 0 },
    {
      id: 'deficiency_punchlist_tracking',
      domain: 'Projects',
      percent: 0,
    },
    {
      id: 'qa_qc_checklists_inspections',
      domain: 'Projects',
      percent: 0,
    },
    { id: 'meeting_minutes', domain: 'Collaboration', percent: 0 },
    { id: 'customizable_workflows', domain: 'Projects', percent: 0 },
    { id: 'daily_reports', domain: 'Projects', percent: 0 },
    { id: 'enterprise_platform', domain: 'Enterprise', percent: 0 },
    { id: 'mobile_apps', domain: 'Mobile', percent: 0 },
    { id: 'folder_roles_security', domain: 'Enterprise', percent: 0 },
    {
      id: 'realtime_mult_user_collab',
      domain: 'Collaboration',
      percent: 0,
    },
    { id: 'auto_free_updates', domain: 'Enterprise', percent: 0 },
    {
      id: 'project_sharing_invites',
      domain: 'Collaboration',
      percent: 0,
    },
    {
      id: 'simultaneous_project_access',
      domain: 'Collaboration',
      percent: 0,
    },
    { id: 'unlimited_projects_docs', domain: 'Projects', percent: 0 },
    { id: 'cloud_anywhere_access', domain: 'Enterprise', percent: 0 },
    {
      id: 'unlimited_viewer_seats',
      domain: 'Enterprise',
      percent: 0,
    },
    {
      id: 'full_enterprise_capabilities',
      domain: 'Enterprise',
      percent: 0,
    },
    { id: 'takeoff_tools', domain: 'Estimation', percent: 0 },
    { id: 'robust_takeoff_tools', domain: 'Estimation', percent: 0 },
    {
      id: 'flexible_takeoff_organization',
      domain: 'Estimation',
      percent: 0,
    },
    {
      id: 'prebuilt_item_assembly_library',
      domain: 'Estimation',
      percent: 0,
    },
    { id: 'overlay_drawing_versions', domain: 'Plans', percent: 0 },
    { id: 'markup_collaborate_plans', domain: 'Plans', percent: 0 },
    { id: 'metric_imperial_units', domain: 'Plans', percent: 0 },
    { id: 'symbol_search_recognition', domain: 'Plans', percent: 0 },
    { id: 'auto_plan_hyperlinking', domain: 'Plans', percent: 0 },
    { id: 'auto_plan_naming', domain: 'Plans', percent: 0 },
    { id: 'chat_on_plans', domain: 'Plans', percent: 0 },
    {
      id: 'estimate_materials_labor',
      domain: 'Estimation',
      percent: 0,
    },
    {
      id: 'worksheet_style_estimating',
      domain: 'Estimation',
      percent: 0,
    },
    { id: 'integrated_excel', domain: 'Estimation', percent: 0 },
    { id: 'rollup_group_sort', domain: 'Estimation', percent: 0 },
    {
      id: 'intuitive_estimate_dashboard',
      domain: 'Estimation',
      percent: 0,
    },
    {
      id: 'dynamic_estimate_scopes',
      domain: 'Estimation',
      percent: 0,
    },
    { id: 'bni_cost_library', domain: 'Estimation', percent: 0 },
    {
      id: 'missing_materials_identification',
      domain: 'Estimation',
      percent: 0,
    },
    { id: 'non_takeoff_costs', domain: 'Estimation', percent: 0 },
  ];

  const [features, setFeatures] = useState(initialFeatures);
  const [activeFilters, setActiveFilters] = useState([]);
  const [showDomainSummaries, setShowDomainSummaries] = useState(false);
  const [completionLevelFilters, setCompletionLevelFilters] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [viewMode, setViewMode] = useState('grid');
  const [ganttTimeScale, setGanttTimeScale] = useState(2); // 1, 2, or 3 years
  const [ganttBaseYear, setGanttBaseYear] = useState(2026);

  // Initialize auth listener and load data from Firebase
  useEffect(() => {
    const unsubscribe = firebase.auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        setCurrentUser(authUser);
        try {
          // Try to fetch features from Firestore
          let savedFeatures = await firebase.doGetFeatureCompletionData(authUser.uid);
          
          // If no features in Firebase, check localStorage for migration
          if (!savedFeatures || !Array.isArray(savedFeatures) || savedFeatures.length === 0) {
            const localStorageData = localStorage.getItem('dashboardFeatures');
            if (localStorageData) {
              try {
                const parsedData = JSON.parse(localStorageData);
                if (Array.isArray(parsedData) && parsedData.length > 0) {
                  console.log('🔄 Migrating localStorage data to Firebase...');
                  // Extract just the essential fields (id, domain, percent) for consistency
                  const migratedData = parsedData.map(f => ({
                    id: f.id,
                    domain: f.domain,
                    percent: f.percent || 0
                  }));
                  await firebase.doSaveFeatureCompletionData(authUser.uid, migratedData);
                  setFeatures(migratedData);
                  localStorage.removeItem('dashboardFeatures'); // Clear localStorage after successful migration
                  console.log('✅ Successfully migrated localStorage data to Firebase');
                }
              } catch (parseError) {
                console.error('Error parsing localStorage data:', parseError);
              }
            }
          } else if (Array.isArray(savedFeatures)) {
            setFeatures(savedFeatures);
          }
        } catch (error) {
          console.error('Error loading features from Firebase:', error);
          // Fall back to initial features if there's an error
        }
      } else {
        // User not logged in - use initial features in memory only
        setCurrentUser(null);
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Save to Firebase whenever features change
  useEffect(() => {
    if (!isLoading && currentUser) {
      // Debounce saves to avoid too many writes
      const saveTimeout = setTimeout(async () => {
        try {
          await firebase.doSaveFeatureCompletionData(currentUser.uid, features);
          console.log('✅ Feature data saved to Firebase');
        } catch (error) {
          console.error('Error saving to Firebase:', error);
        }
      }, 1000);

      return () => clearTimeout(saveTimeout);
    }
  }, [features, currentUser, isLoading]);

  const updateFeature = (id, value) => {
    const percent = Math.max(0, Math.min(100, Number(value)));
    setFeatures((prev) =>
      prev.map((f) => (f.id === id ? { ...f, percent } : f)),
    );
  };

  // Gantt date range helpers
  const GANTT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Memoize timeline calculations - only recalculate when ganttBaseYear or ganttTimeScale changes
  const timelineData = useMemo(() => {
    const startDate = new Date(ganttBaseYear, 0, 1); // Jan 1 of base year
    const endDate = new Date(ganttBaseYear + ganttTimeScale, 0, 1); // Jan 1 of end year
    const totalDays = (endDate - startDate) / (1000 * 60 * 60 * 24);
    return { startDate, endDate, totalDays };
  }, [ganttBaseYear, ganttTimeScale]);

  // Convert feature date to display label
  const dateToLabel = (year, month, day) => {
    if (!year || month === undefined) return '';
    const dayStr = day ? ` ${day}` : '';
    return ganttTimeScale === 1 
      ? `${GANTT_MONTHS[month]}${dayStr}` 
      : `${GANTT_MONTHS[month]}${dayStr}, ${year}`;
  };

  // Convert slider position (0-100) to actual date based on timeline scale
  const positionToDate = useCallback((pos) => {
    // Calculate target date using memoized timeline data
    const dayOffset = Math.floor((pos / 100) * timelineData.totalDays);
    const targetDate = new Date(timelineData.startDate.getTime() + dayOffset * 1000 * 60 * 60 * 24);
    
    return { 
      year: targetDate.getFullYear(), 
      month: targetDate.getMonth(), 
      day: targetDate.getDate() 
    };
  }, [timelineData]);

  // Convert actual date to slider position (0-100)
  const dateToPosition = useCallback((year, month, day = 1) => {
    if (!year || month === undefined) return 0;
    
    // Calculate target date position using memoized timeline data
    const targetDate = new Date(year, month, day || 1);
    const dayOffset = (targetDate - timelineData.startDate) / (1000 * 60 * 60 * 24);
    
    return Math.max(0, Math.min(100, (dayOffset / timelineData.totalDays) * 100));
  }, [timelineData]);

  const updateGanttRange = (id, field, value) => {
    const pos = Math.max(0, Math.min(100, Number(value)));
    const date = positionToDate(pos);
    
    setFeatures((prev) =>
      prev.map((f) => {
        if (f.id !== id) return f;
        
        // Store dates as objects
        const updated = { ...f };
        if (field === 'ganttStart') {
          updated.ganttStart = { year: date.year, month: date.month, day: date.day };
          // Ensure start <= end
          if (f.ganttEnd) {
            const startDate = new Date(date.year, date.month, date.day);
            const endDate = new Date(f.ganttEnd.year, f.ganttEnd.month, f.ganttEnd.day);
            if (startDate > endDate) {
              updated.ganttEnd = { year: date.year, month: date.month, day: date.day };
            }
          }
        } else if (field === 'ganttEnd') {
          updated.ganttEnd = { year: date.year, month: date.month, day: date.day };
          // Ensure start <= end
          if (f.ganttStart) {
            const startDate = new Date(f.ganttStart.year, f.ganttStart.month, f.ganttStart.day);
            const endDate = new Date(date.year, date.month, date.day);
            if (endDate < startDate) {
              updated.ganttStart = { year: date.year, month: date.month, day: date.day };
            }
          }
        }
        
        return updated;
      }),
    );
  };

  const toggleFilter = (domain) => {
    setActiveFilters((prev) =>
      prev.includes(domain)
        ? prev.filter((d) => d !== domain)
        : [...prev, domain],
    );
  };

  const clearFilters = () => {
    setActiveFilters([]);
    setCompletionLevelFilters([]);
  };

  const importDataFromJSON = (jsonData) => {
    try {
      let data;
      if (typeof jsonData === 'string') {
        data = JSON.parse(jsonData);
      } else {
        data = jsonData;
      }

      if (!Array.isArray(data)) {
        throw new Error('Data must be an array');
      }

      // Extract essential fields and normalize the data
      const importedData = data.map(f => ({
        id: f.id,
        domain: f.domain,
        percent: Math.min(100, Math.max(0, f.percent || 0))
      }));

      setFeatures(importedData);
      if (currentUser) {
        firebase.doSaveFeatureCompletionData(currentUser.uid, importedData).then(() => {
          console.log('✅ Data imported and saved to Firebase');
        });
      }
      return true;
    } catch (error) {
      console.error('Error importing data:', error);
      return false;
    }
  };

  const toggleCompletionFilter = (level) => {
    setCompletionLevelFilters((prev) =>
      prev.includes(level)
        ? prev.filter((l) => l !== level)
        : [...prev, level],
    );
  };

  const getUniqueDomains = () => {
    return [...new Set(features.map((f) => f.domain))].sort();
  };

  const getCompletionLevel = (percent) => {
    if (percent === 0) return 'not_started';
    if (percent < 50) return 'in_progress';
    if (percent < 100) return 'in_progress';
    return 'deployed';
  };

  const getFilteredFeatures = () => {
    let filtered = features;

    // Filter by domain
    if (activeFilters.length > 0) {
      filtered = filtered.filter((f) =>
        activeFilters.includes(f.domain),
      );
    }

    // Filter by completion level
    if (completionLevelFilters.length > 0) {
      filtered = filtered.filter((f) =>
        completionLevelFilters.includes(getCompletionLevel(f.percent)),
      );
    }

    return filtered;
  };

  const calculateStats = () => {
    const allFeatures = features;
    const overallPercent =
      allFeatures.length > 0
        ? Math.round(
            allFeatures.reduce((acc, f) => acc + f.percent, 0) /
              allFeatures.length,
          )
        : 0;

    const deployed = allFeatures.filter(
      (f) => f.percent === 100,
    ).length;
    const inProgress = allFeatures.filter(
      (f) => f.percent > 0 && f.percent < 100,
    ).length;
    const notStarted = allFeatures.filter(
      (f) => f.percent === 0,
    ).length;

    return {
      overallPercent,
      deployed,
      inProgress,
      notStarted,
      total: allFeatures.length,
    };
  };

  const getDomainStats = () => {
    const domains = getUniqueDomains();
    return domains.map((domain) => {
      const domainFeatures = features.filter(
        (f) => f.domain === domain,
      );
      const avg =
        domainFeatures.length > 0
          ? Math.round(
              domainFeatures.reduce((acc, f) => acc + f.percent, 0) /
                domainFeatures.length,
            )
          : 0;
      return { domain, percent: avg, count: domainFeatures.length };
    });
  };

  const stats = calculateStats();
  const filteredFeatures = getFilteredFeatures();
  const domainStats = getDomainStats();

  // Sync scroll position across all gantt scroll containers
  useEffect(() => {
    if (viewMode !== 'gantt') return;

    const handleScroll = (e) => {
      const scrollLeft = e.target.scrollLeft;
      const scrollContainers = document.querySelectorAll('.fcd-gantt-scroll-container');
      
      scrollContainers.forEach((container) => {
        if (container !== e.target && container.scrollLeft !== scrollLeft) {
          container.scrollLeft = scrollLeft;
        }
      });
    };

    // Small delay to ensure DOM is ready after render
    const timeoutId = setTimeout(() => {
      const scrollContainers = document.querySelectorAll('.fcd-gantt-scroll-container');
      scrollContainers.forEach((container) => {
        container.addEventListener('scroll', handleScroll);
      });
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      const scrollContainers = document.querySelectorAll('.fcd-gantt-scroll-container');
      scrollContainers.forEach((container) => {
        container.removeEventListener('scroll', handleScroll);
      });
    };
  }, [viewMode, ganttTimeScale, ganttBaseYear, activeFilters, completionLevelFilters]);

  if (isLoading) {
    return (
      <div className="fcd-container">
        <main className="fcd-main">
          <h1>{t('featureDashboard.title')}</h1>
          <p className="fcd-subtitle" style={{ textAlign: 'center', color: 'var(--pico-muted-color)' }}>
            Loading...
          </p>
        </main>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="fcd-container">
        <main className="fcd-main">
          <h1>{t('featureDashboard.title')}</h1>
          <p className="fcd-subtitle" style={{ textAlign: 'center', color: 'var(--pico-muted-color)', marginBottom: '2rem' }}>
            Please log in to save your feature completion data to Firebase.
          </p>
          <p style={{ textAlign: 'center', color: 'var(--pico-muted-color)' }}>
            Data will be saved locally and synced when you log in.
          </p>
        </main>
      </div>
    );
  }

  return (
    <div className="fcd-container">
      <main className="fcd-main">
        <h1>{t('featureDashboard.title')}</h1>
        <p className="fcd-subtitle">
          {t('featureDashboard.subtitle')}
        </p>
        <p style={{ fontSize: '0.85rem', color: 'var(--pico-muted-color)', marginBottom: '1rem' }}>
          💾 Synced to Firebase • {currentUser?.email}
        </p>

        {/* Overall Progress */}
        <div className="fcd-progress-box">
          <h2>{t('featureDashboard.overall_progress')}</h2>
          <p className="fcd-overall-percent">
            {stats.overallPercent}%
          </p>
          <progress
            value={stats.overallPercent}
            max="100"
            className="fcd-progress-bar"
          />
          <p className="fcd-feature-stats">
            {stats.deployed} {t('featureDashboard.deployed')} •{' '}
            {stats.inProgress} {t('featureDashboard.in_progress')} •{' '}
            {stats.notStarted} {t('featureDashboard.not_started')} •{' '}
            {stats.total} {t('featureDashboard.total')}
          </p>
        </div>
        {/* Toggle Domain Summaries Button */}
        <div className="fcd-toggle-domains">
          <button
            className="fcd-toggle-btn"
            onClick={() =>
              setShowDomainSummaries(!showDomainSummaries)
            }
          >
            {showDomainSummaries ? '▼' : '▶'}{' '}
            {t('featureDashboard.domain_summary')}
          </button>
          {activeFilters.length > 0 && (
            <button
              className="fcd-clear-filters-btn"
              onClick={() => clearFilters()}
            >
              {t('featureDashboard.clear_all_filters')}
            </button>
          )}
          {currentUser && (
            <div style={{ fontSize: '0.75rem', color: 'var(--pico-muted-color)', marginLeft: 'auto' }}>
              Synced to {currentUser.email || 'Firebase'}
            </div>
          )}
        </div>
        {/* Domain Summary at Top */}
        {showDomainSummaries && (
          <div className="fcd-summary-by-domain fcd-summary-expanded">
            {domainStats.map((d) => (
              <div
                key={d.domain}
                className={`fcd-domain-summary ${activeFilters.includes(d.domain) ? 'active' : ''}`}
                onClick={() => toggleFilter(d.domain)}
              >
                <h4>{d.domain}</h4>
                <div className="fcd-domain-percent">{d.percent}%</div>
                <progress
                  value={d.percent}
                  max="100"
                  className="fcd-domain-progress"
                />
                <p>
                  {d.count} {t('featureDashboard.features')}
                </p>
              </div>
            ))}
          </div>
        )}

        {/* Domain Filters - HIDDEN */}
        <div
          className="fcd-filters-section"
          style={{ display: 'none' }}
        >
          <p>
            <strong>{t('featureDashboard.filter_by_domain')}</strong>
          </p>
          <div className="fcd-feature-filters">
            {getUniqueDomains().map((domain) => (
              <button
                key={domain}
                className={`fcd-filter-btn ${activeFilters.includes(domain) ? 'active' : ''}`}
                onClick={() => toggleFilter(domain)}
              >
                {domain}
              </button>
            ))}
          </div>
          <button className="fcd-clear-btn" onClick={clearFilters}>
            {t('featureDashboard.clear_all_filters')}
          </button>
        </div>

        {/* View Mode Toggle */}
        <div className="fcd-view-toggle">
          <button
            className={`fcd-view-btn ${viewMode === 'grid' ? 'active' : ''}`}
            onClick={() => setViewMode('grid')}
          >
            ▦ {t('featureDashboard.grid_view') || 'Grid'}
          </button>
          <button
            className={`fcd-view-btn ${viewMode === 'gantt' ? 'active' : ''}`}
            onClick={() => setViewMode('gantt')}
          >
            ▬ {t('featureDashboard.gantt_view') || 'Gantt'}
          </button>
        </div>

        {/* Gantt Timeline Controls */}
        {viewMode === 'gantt' && (
          <div className="fcd-gantt-controls">
            <div className="fcd-gantt-control-group">
              <label className="fcd-gantt-control-label">Timeline:</label>
              <button
                className={`fcd-gantt-scale-btn ${ganttTimeScale === 1 ? 'active' : ''}`}
                onClick={() => setGanttTimeScale(1)}
              >
                1 Year
              </button>
              <button
                className={`fcd-gantt-scale-btn ${ganttTimeScale === 2 ? 'active' : ''}`}
                onClick={() => setGanttTimeScale(2)}
              >
                2 Years
              </button>
              <button
                className={`fcd-gantt-scale-btn ${ganttTimeScale === 3 ? 'active' : ''}`}
                onClick={() => setGanttTimeScale(3)}
              >
                3 Years
              </button>
            </div>
            <div className="fcd-gantt-control-group">
              <label className="fcd-gantt-control-label">Start Year:</label>
              <select 
                className="fcd-gantt-year-select"
                value={ganttBaseYear}
                onChange={(e) => setGanttBaseYear(parseInt(e.target.value))}
              >
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
              </select>
            </div>
          </div>
        )}

        {/* Completion Level Filter */}
        <div className="fcd-completion-filter">
          <p className="fcd-filter-label">
            <strong>{t('featureDashboard.filter_by_completion')}</strong>
          </p>
          <div className="fcd-completion-buttons">
            <button
              className={`fcd-completion-btn ${completionLevelFilters.includes('not_started') ? 'active' : ''}`}
              onClick={() => toggleCompletionFilter('not_started')}
            >
              🔴 {t('featureDashboard.not_started')}
            </button>
            <button
              className={`fcd-completion-btn ${completionLevelFilters.includes('in_progress') ? 'active' : ''}`}
              onClick={() => toggleCompletionFilter('in_progress')}
            >
              🟡 {t('featureDashboard.in_progress')}
            </button>
            <button
              className={`fcd-completion-btn ${completionLevelFilters.includes('deployed') ? 'active' : ''}`}
              onClick={() => toggleCompletionFilter('deployed')}
            >
              🟢 {t('featureDashboard.deployed')}
            </button>
          </div>
        </div>

        {/* Features Grid */}
        {viewMode === 'grid' && (
          <div className="fcd-features-grid">
            {filteredFeatures.map((f) => {
              let status =
                f.percent === 0
                  ? 0
                  : f.percent < 50
                    ? 1
                    : f.percent < 100
                      ? 2
                      : 3;
              return (
                <div
                  key={f.id}
                  className={`fcd-feature-row fcd-status-${status}`}
                >
                  <div>
                    <div className="fcd-feature-name">
                      {t(`featureDashboard.feature_names.${f.id}`)}
                    </div>
                  </div>
                  <div className="fcd-feature-input">
                    <input
                      type="range"
                      className="fcd-range-slider"
                      min="0"
                      max="100"
                      value={f.percent}
                      onChange={(e) =>
                        updateFeature(f.id, e.target.value)
                      }
                    />
                    <span className="fcd-percent-display">
                      {f.percent}%
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Gantt View */}
        {viewMode === 'gantt' && (
          <div className="fcd-gantt">
            {/* Gantt header with month labels */}
            <div className="fcd-gantt-header">
              <div className="fcd-gantt-label-col">{t('featureDashboard.feature') || 'Feature'}</div>
              <div className="fcd-gantt-scroll-container">
                <div className="fcd-gantt-bar-col" style={{ minWidth: ganttTimeScale > 1 ? `${ganttTimeScale * 100}%` : '100%' }}>
                  {Array.from({ length: ganttTimeScale * 12 }).map((_, i) => {
                    const year = ganttBaseYear + Math.floor(i / 12);
                    const monthIdx = i % 12;
                    const month = GANTT_MONTHS[monthIdx];
                    const label = ganttTimeScale === 1 ? month : (monthIdx === 0 || i === 0 ? `${month} ${year}` : month);
                    return (
                      <span
                        key={i}
                        className="fcd-gantt-tick"
                        style={{ left: `${(i / (ganttTimeScale * 12)) * 100}%` }}
                      >
                        {label}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Group by domain */}
            {getUniqueDomains()
              .filter((domain) =>
                activeFilters.length === 0 || activeFilters.includes(domain)
              )
              .map((domain) => {
                const domainFeatures = filteredFeatures.filter(
                  (f) => f.domain === domain
                );
                if (domainFeatures.length === 0) return null;
                return (
                  <div key={domain} className="fcd-gantt-domain-group">
                    <div className="fcd-gantt-domain-header">
                      <div className="fcd-gantt-label-col" >
                        <span className="fcd-gantt-domain-name">{domain}</span>
                        {/* <span className="fcd-gantt-domain-count">
                          {domainFeatures.length} {t('featureDashboard.features') || 'features'}
                        </span> */}
                      </div>
                      <div className="fcd-gantt-scroll-container" style={{scrollbarWidth: "none"}}>
                        <div className="fcd-gantt-bar-col" style={{ minWidth: ganttTimeScale > 1 ? `${ganttTimeScale * 100}%` : '100%' }}>
                          <div className="fcd-gantt-domain-timeline">
                            {(() => {
                              // Calculate domain summary timeline
                              let domainStart = null;
                              let domainEnd = null;
                              
                              domainFeatures.forEach(f => {
                                // Handle both old and new format
                                let start = f.ganttStart;
                                let end = f.ganttEnd;
                                
                                if (!start && f.ganttStartYear !== undefined && f.ganttStartMonth !== undefined) {
                                  start = { year: f.ganttStartYear, month: f.ganttStartMonth, day: f.ganttStartDay || 1 };
                                }
                                if (!end && f.ganttEndYear !== undefined && f.ganttEndMonth !== undefined) {
                                  end = { year: f.ganttEndYear, month: f.ganttEndMonth, day: f.ganttEndDay || 1 };
                                }
                                
                                if (start) {
                                  const startDate = new Date(start.year, start.month, start.day);
                                  if (!domainStart || startDate < domainStart) {
                                    domainStart = startDate;
                                  }
                                }
                                
                                if (end) {
                                  const endDate = new Date(end.year, end.month, end.day);
                                  if (!domainEnd || endDate > domainEnd) {
                                    domainEnd = endDate;
                                  }
                                }
                              });
                              
                              // Render grid lines
                              const gridLines = Array.from({ length: ganttTimeScale * 12 }).map((_, i) => (
                                <div
                                  key={i}
                                  className="fcd-gantt-gridline"
                                  style={{ left: `${(i / (ganttTimeScale * 12)) * 100}%` }}
                                />
                              ));
                              
                              if (domainStart && domainEnd) {
                                const startPos = dateToPosition(
                                  domainStart.getFullYear(), 
                                  domainStart.getMonth(), 
                                  domainStart.getDate()
                                );
                                const endPos = dateToPosition(
                                  domainEnd.getFullYear(), 
                                  domainEnd.getMonth(), 
                                  domainEnd.getDate()
                                );
                                
                                return (
                                  <>
                                    {gridLines}
                                    <div className="fcd-gantt-domain-summary-bar" 
                                         style={{ 
                                           left: `${startPos}%`, 
                                           width: `${endPos - startPos}%`
                                         }}>
                                      {(endPos - startPos) > 12 && (
                                        <span className="fcd-gantt-domain-summary-label">
                                          {dateToLabel(domainStart.getFullYear(), domainStart.getMonth(), domainStart.getDate())} 
                                          {' – '}
                                          {dateToLabel(domainEnd.getFullYear(), domainEnd.getMonth(), domainEnd.getDate())}
                                        </span>
                                      )}
                                    </div>
                                  </>
                                );
                              }
                              return gridLines;
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                    {domainFeatures.map((f) => {
                      // Migrate old format to new format
                      let start = f.ganttStart;
                      let end = f.ganttEnd;
                      
                      // Backward compatibility: convert old separate properties to object format
                      if (!start && f.ganttStartYear !== undefined && f.ganttStartMonth !== undefined) {
                        start = { 
                          year: f.ganttStartYear, 
                          month: f.ganttStartMonth, 
                          day: f.ganttStartDay || 1 
                        };
                      }
                      if (!end && f.ganttEndYear !== undefined && f.ganttEndMonth !== undefined) {
                        end = { 
                          year: f.ganttEndYear, 
                          month: f.ganttEndMonth, 
                          day: f.ganttEndDay || 1 
                        };
                      }
                      
                      // Calculate positions and check if valid range exists
                      const startPos = start ? dateToPosition(start.year, start.month, start.day) : 0;
                      const endPos = end ? dateToPosition(end.year, end.month, end.day) : 0;
                      
                      // Check if valid range using Date comparison
                      const hasRange = start && end && 
                        new Date(start.year, start.month, start.day) < new Date(end.year, end.month, end.day);
                      const barColor = hasRange ? '#1095c1' : '#999';
                      
                      return (
                        <div key={f.id} className="fcd-gantt-row">
                          <div className="fcd-gantt-label-col">
                            <span className="fcd-gantt-task-name">
                              {t(`featureDashboard.feature_names.${f.id}`)}
                            </span>
                            {hasRange && (
                              <span className="fcd-gantt-date-hint">
                                {dateToLabel(start.year, start.month, start.day)} – {dateToLabel(end.year, end.month, end.day)}
                              </span>
                            )}
                          </div>
                          <div className="fcd-gantt-scroll-container" style={{scrollbarWidth: "none"}}>
                            <div className="fcd-gantt-bar-col" style={{ minWidth: ganttTimeScale > 1 ? `${ganttTimeScale * 100}%` : '100%' }}>
                              <div className="fcd-gantt-track">
                                {/* Month grid lines */}
                                {Array.from({ length: ganttTimeScale * 12 }).map((_, i) => (
                                  <div
                                    key={i}
                                    className="fcd-gantt-gridline"
                                    style={{ left: `${(i / (ganttTimeScale * 12)) * 100}%` }}
                                  />
                                ))}
                                {/* Visual bar between start and end */}
                                {hasRange && (
                                  <div
                                    className="fcd-gantt-bar"
                                    style={{
                                      left: `${startPos}%`,
                                      width: `${endPos - startPos}%`,
                                      background: barColor,
                                    }}
                                  >
                                    {(endPos - startPos) > 8 && (
                                      <span className="fcd-gantt-bar-label">
                                        {dateToLabel(start.year, start.month, start.day)} – {dateToLabel(end.year, end.month, end.day)}
                                      </span>
                                    )}
                                  </div>
                                )}
                                {/* Dual range sliders */}
                                <input
                                  type="range"
                                  className="fcd-gantt-slider fcd-gantt-slider-start"
                                  min="0"
                                  max="100"
                                  step="0.1"
                                  value={startPos}
                                  onChange={(e) =>
                                    updateGanttRange(f.id, 'ganttStart', e.target.value)
                                  }
                                  title={`Start: ${start ? dateToLabel(start.year, start.month, start.day) : 'Not set'}`}
                                />
                                <input
                                  type="range"
                                  className="fcd-gantt-slider fcd-gantt-slider-end"
                                  min="0"
                                  max="100"
                                  step="0.1"
                                  value={endPos}
                                  onChange={(e) =>
                                    updateGanttRange(f.id, 'ganttEnd', e.target.value)
                                  }
                                  title={`End: ${end ? dateToLabel(end.year, end.month, end.day) : 'Not set'}`}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        )}
      </main>
    </div>
  );
};

export default FeatureCompletionDashboard;
